import axios from "axios";
import { AUTH_TOKEN_KEY } from "../../constants/localstorageKeys";
import routes from "../../configs/api";

const getVendors = async () => {

  const token = localStorage.getItem(AUTH_TOKEN_KEY);
  const URL = `${routes.GET_VENDOR_LIST}`;

  console.log("URL", URL);
  

//   const res = await axios.get(URL, {
//     headers: { Authorization: `Bearer ${token}` },
//   });

  return new Promise((resolve, reject) => {
      axios
        .get(URL, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
};

export default getVendors;
